import { makeStyles } from "@material-ui/core/styles";
import { secondary, white, black } from "../../../assets/variables.module.scss";

const useStyles = ({ activeType }) =>
  makeStyles((theme) => ({
    button: {
      borderRadius: theme.spacing(8),
      "&.active": {
        backgroundColor: activeType === "primary" ? secondary : white,
        color: activeType === "primary" ? white : black,
        "& svg": {
          color: activeType === "primary" ? white : secondary,
          "&.reset": {
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(0),
          },
        },
      },
      "& svg": {
        cursor: "pointer",
        color: activeType === "primary" ? secondary : white,
        marginLeft: theme.spacing(2),
      },
    },
    select: { visibility: "hidden", position: "absolute", left: 0 },
  }));

export default useStyles;
